<template>
  <div>
    <visit
      v-bind="$attrs"
      title="客服回访"
      type="writeOperate"
      ref="visit"
      @editLog="editLog"
      override-edit-item
      no-appointment
    >
      <el-button
        slot="add-btn"
        size="medium"
        type="primary"
        class="jm-button-search"
        @click="doAdd"
      >新增</el-button>

      <el-button
        slot="editBtn"
        size="mini"
        type="primary"
      >编辑</el-button>
    </visit>
    <el-dialog class="dialog" :title="dialogFormTitle" :visible.sync="dialogFormVisible">
      <el-form :model="form" style="width: 90%; margin-top: 30px">
        <el-form-item label="回访记录" label-width="120px">
          <el-input type="textarea" v-model="form.content" autocomplete="off" rows="5"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveLog">保存</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const visit = () => import('@/components/visit');

export default {
  name: 'CustomerServiceLog',
  data() {
    return {
      dialogFormTitle: '新增回访',
      dialogFormVisible: false,
      form: {
        content: '',
        id: 0,
        userid: 0,
        type: 1
      },
    };
  },
  components: {
    visit,
  },
  methods: {
    doAdd() {
      this.dialogFormVisible = true;
      this.form.content = '';
      this.form.id = 0;
    },
    editLog(data) {
      this.dialogFormTitle = '编辑回访';
      this.dialogFormVisible = true;
      this.form.content = data.content;
      this.form.id = data.id;
    },
    async saveLog() {
      await this.$http._post({
        url: '/index/customer_service_visit/resource',
        data: this.form
      });
      this.dialogFormVisible = false;
      this.$message.success('保存成功');
      this.$refs.visit.doRefresh();
    },
    refreshList() {
      this.$refs.visit.doRefresh();
    },
  },
  created() {
    this.form.userid = this.$route.params.id;
  }
};
</script>
